export var TextAlignment = /*#__PURE__*/function (TextAlignment) {
  TextAlignment[TextAlignment["Left"] = 0] = "Left";
  TextAlignment[TextAlignment["Center"] = 1] = "Center";
  TextAlignment[TextAlignment["Right"] = 2] = "Right";
  return TextAlignment;
}(TextAlignment || {});

